const ORDER_REASON_TYPE_ID = {
  CONFIRM: 1,
  DETAIL: 2,
  END: 3,
  ARRIVAL_DATE: 4
}
const ORDER_REASON_TYPE_LABEL = {
  CONFIRM: '発注内容確認',
  DETAIL: '発注内容不備',
  END: '注文商品終売',
  ARRIVAL_DATE: '注文商品入荷日未定'
}
export default {
  ORDER_REASON_TYPE_ID,
  ORDER_REASON_TYPE_LABEL
}
